export const handleWindowMouseMove =
  ({ tab_el }) =>
  (event) => {
    if (tab_el.__mp_is_prevent_mouse_move) {
      event.preventDefault();
    }
  };
